import {
  PublicServiceGroupRelation,
  ServiceGroupedServicesPayload,
  ServiceGroupedServicesResponse,
} from '@/models/service/serviceGroup.model'
import axios from 'axios'
import { Ref } from 'vue'
import { useMutation, useQueryClient } from 'vue-query'

const serviceGroupedServicesKeys = {
  all: ['serviceGroupedServices'] as const,
  lists: () => [...serviceGroupedServicesKeys.all, 'list'] as const,
  list: (companyId: Ref<number | null>, serviceId: number | undefined) =>
    [...serviceGroupedServicesKeys.lists(), { companyId, serviceId }] as const,
}

export function useFetchServiceGroupedServices(
  companyId: Ref<number | null>,
  serviceId: number | undefined,
) {
  const queryClient = useQueryClient()
  return useMutation(
    async () => {
      const { data } = await axios.get<ServiceGroupedServicesResponse>(
        `companies/${companyId.value}/services/${serviceId}/grouped-services/`,
      )
      return data
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(
          serviceGroupedServicesKeys.list(companyId, serviceId),
          data,
        )
      },
    },
  )
}

export function useUpdateServiceGroupedServices(
  companyId: Ref<number | null>,
  serviceId: number | undefined,
) {
  const queryClient = useQueryClient()
  return useMutation(
    async (payload: ServiceGroupedServicesPayload) => {
      const { data } = await axios.put<ServiceGroupedServicesResponse>(
        `companies/${companyId.value}/services/${serviceId}/grouped-services/`,
        payload,
      )
      return data
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(
          serviceGroupedServicesKeys.list(companyId, serviceId),
          data,
        )
      },
    },
  )
}

export function useFetchPublicGroupedServicesMutation(
  serviceId: Ref<string | number | null>,
  isPreview: boolean,
) {
  return useMutation(async () => {
    // Preview endpoint is for service provider user usage in service preview
    const serviceUrl = isPreview
      ? `public/service/${serviceId.value}/grouped-services/preview/`
      : `public/service/${serviceId.value}/grouped-services/`

    const { data } = await axios.get<PublicServiceGroupRelation[]>(serviceUrl)
    return data
  })
}
